'use client';
import { useState, useRef, useEffect } from 'react';

function useDebouncedState(/** Значение по умолчанию */ defaultValue, /** Время, через которое будет обновлено значение */ wait, /** Дополнительные опции */ options = {
    /** Свойство указывающее на то что в первый раз значение будет обновлено моментально, далее с задержкой */ leading: false
}) {
    const [value, setValue] = useState(defaultValue);
    const timeoutRef = useRef(undefined);
    const leadingRef = useRef(true);
    const clearTimeout = ()=>window.clearTimeout(timeoutRef.current);
    useEffect(()=>clearTimeout, []);
    const debouncedSetValue = (newValue)=>{
        clearTimeout();
        if (leadingRef.current && options.leading) {
            setValue(newValue);
        } else {
            timeoutRef.current = window.setTimeout(()=>{
                leadingRef.current = true;
                setValue(newValue);
            }, wait);
        }
        leadingRef.current = false;
    };
    return [
        value,
        debouncedSetValue
    ];
}

export { useDebouncedState };
//# sourceMappingURL=useDebouncedState.js.map
